import { Box, Card, Grid } from '@mui/material';
import { useDispatch } from 'react-redux';

import Axios from '../../services';

import { actions as authActios, constants as authConstants } from '../../store/domains/auth';

const SelectProvider = () => {
  const dispatch = useDispatch();

  const handleProvider = (id) => {
    dispatch(authActios.setProviderID(id));
    localStorage.setItem('providerId', id);
    Axios.defaults.headers['Provider-Id'] = id;
    const userType = authConstants.getUserType();
    if (userType === 'DISTRIBUTOR_ADMIN') window.location.assign('/dashboard/start-pack');
    else if (userType === 'DEALER_SERVICE') window.location.assign('/dashboard/transfer-ownership');
    else window.location.assign('/dashboard/dealer-archive');
  };

  return (
    <Grid marginTop={5} spacing={2} container display="flex" justifyContent="center">
      <Grid
        sx={{
          cursor: 'pointer',
        }}
        xs={4}
        item
        onClick={() => handleProvider(2)}
      >
        <Card>
          <Box height={150} padding={4}>
            <img
              style={{
                margin: 'auto',
              }}
              src="/images/bakcell.svg"
              alt="bakcell"
            />
          </Box>
        </Card>{' '}
      </Grid>
      <Grid
        sx={{
          cursor: 'pointer',
        }}
        xs={4}
        item
        onClick={() => handleProvider(1)}
      >
        <Card>
          <Box height={150} padding={4}>
            <img
              style={{
                margin: 'auto',
              }}
              src="/images/nar.svg"
              alt="nar"
            />
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SelectProvider;
